import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import { WOUND_ALLOCATION_PHASE } from 'types/phases'

const BattleTraits = {
  Death: {
    effects: [
      {
        name: `Deathless Minions`,
        desc: `Each time you allocate a wound or mortal wound to a friendly DEATH model within 6" of your general or a friendly DEATH HERO, roll a dice. On a 6+ the wound is negated.`,
        when: [WOUND_ALLOCATION_PHASE],
      },
    ],
  }, 
} satisfies TItemDescriptions

export default tagAs(BattleTraits, 'battle_trait')
